export default {
  namespaced: true,
  assigned_regions: {
    title: "Regiones asignadas",
    single: "región asignada",
    all: "todas las regiones asignadas",

    current_assignment: "asignación actual",
    schedule_regions: "programar regiones",
    change: "cambiar",
    change_now: "cambiar ahora",

    region: "región",
    regions: "regiones",
    sector: "sector",
    sectors: "sectores",

    analyst: "analista",
    supervisor: "supervisor",
    change_supervisor: "cambiar supervisor",
    change_sectors: "cambiar regiones",

    scheduled: "programado",
    programmed: "programado",
    manual_change: "cambio manual",

    init_date: "fecha de inicio",
    end_date: "fecha de fin",
    active_at: "activo en",
    active_at_help: "Filtra asignaciones activas en una fecha y hora específica.",
    since: "desde",

    select_supervisor: "selecciona un supervisor",
    select_sector: "selecciona una región",
    select_sectors: "selecciona regiones",
    select_analyst: "selecciona un analista",

    supervisor_optional: "El supervisor es opcional.",
    no_supervisor: "sin supervisor asignado",
    no_regions: "sin regiones asignadas",

    effective_assignment: "asignación efectiva",
    assignment_history: "historial de asignaciones",
    programmed_assignment: "asignación programada",
    current_supervisor: "supervisor actual",
    current_regions: "regiones actuales",

    save_programmed: "guardar asignación programada",
    save_change: "guardar cambio",

    messages: {
      created: "Asignación creada correctamente.",
      updated: "Asignación actualizada correctamente.",
      deleted: "Asignación eliminada correctamente.",
      changed: "Asignación cambiada correctamente.",
      closed: "El cambio actual se cerró correctamente.",
      load_error: "Error cargando asignaciones.",
      save_error: "Error guardando la asignación.",
      delete_error: "Error eliminando la asignación.",
      change_error: "Error cambiando la asignación.",
      required_supervisor: "Selecciona un supervisor.",
      required_sector: "Selecciona al menos una región.",
    },
  },
};
